module.exports = __webpack_public_path__ + "img/gateway.687a92b9.png";